import { MFATrustedDevice } from '@organization/models'
import { Table, TableProps } from 'antd'
import { useTranslation } from 'react-i18next'

import { getTrustedDevicesTableColumns } from './tableColumns'

type Props = {
  data?: MFATrustedDevice[]
} & TableProps<MFATrustedDevice>

export const TrustedDevicesTable = ({ data, ...props }: Props) => {
  const { t } = useTranslation()

  const columns = getTrustedDevicesTableColumns(t)

  return (
    <Table
      dataSource={data}
      rowKey="id"
      scroll={{ x: 'max-content' }}
      columns={columns}
      {...props}
    />
  )
}
